import getResourceUrl from '../io/api/resource/getResourceUrl'

export const fetchResourceBytes = async (resourceId: string): Promise<Uint8Array | null> => {
  const response = await fetch(getResourceUrl(resourceId))
  if (!response.ok) return null
  return new Uint8Array(await response.arrayBuffer())
}
